import {Component} from '@angular/core';
import {LocalStorage} from '../../global/util/LocalStorage';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  fullYear: number;

  constructor() {
    this.fullYear = new Date().getFullYear();
  }

  get allyName(): string {
    return LocalStorage.getAllyName();
  }
}
